import type { SVGProps } from "react";

export default function ChevronRight(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5094 7.00012L3.67188 11.8376L4.49683 12.6626L10.1593 7.00012L4.49683 1.33764L3.67188 2.1626L8.5094 7.00012Z"
        fill="currentColor"
      />
    </svg>
  );
}
